import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetUser } from '../../hooks/useGetUser';
import CustomLoader from '../ui/CustomLoader';

export function withNoAuth(WrappedComponent) {
  return (props) => {
    const navigate = useNavigate();
    const { isLoggedIn, loading } = useGetUser();

    useEffect(() => {
      if (!loading && isLoggedIn) {
        navigate('/dashboard');
      }
    }, [isLoggedIn, navigate, loading]);

    if (loading) return <CustomLoader />;

    return <WrappedComponent {...props} isLoggedIn={isLoggedIn} />;
  };
}
